import * as z from "zod";
import { zql } from "../generatedDrizzleSchema";
import { userFacingError } from "../userFacingError";
import { workflowNameError } from "../workflowName";
import { mutator } from "./mutator";

export const renameWorkflow = mutator({
  schema: z.object({ workflowId: z.string(), name: z.string() }),
  resolve: {
    workflow: { kind: "workflow", from: "workflowId" },
  },
  permissions: [
    {
      permission: "space:write",
      scopeId: ({ args }) => args.workflow.spaceId,
    },
  ],
  fn: async ({ tx, args: { workflow, name } }) => {
    const trimmed = name.trim();
    const error = workflowNameError(trimmed);
    if (error) throw userFacingError(error);

    const siblings = await tx.run(
      zql.workflows
        .where("spaceId", workflow.spaceId)
        .where("deletedAt", "IS", null)
    );
    const clash = siblings.some(
      (w) =>
        w.id !== workflow.id && w.name.toLowerCase() === trimmed.toLowerCase()
    );
    if (clash)
      throw userFacingError(
        `A workflow named “${trimmed}” already exists in this space.`
      );

    await tx.mutate.workflows.update({
      id: workflow.id,
      name: trimmed,
      needsName: false,
    });
  },
});
